import { KYMW4101Model } from '../kymw4101.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 受注(コード)リスト取得クラス
 *
 * @export OutputKomaSizeDifferenceListService
 * @class OutputKomaSizeDifferenceListService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class OutputKomaSizeDifferenceListService extends PlessJsonResponderSub<any> {

  vo = {
    OrderCode: '',
  };

  // 処理に使用するModel
  private model: KYMW4101Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof OutputKomaSizeDifferenceListService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof OutputKomaSizeDifferenceListService
   */
  execute(model: KYMW4101Model, vo: any, successFunc: Function = null): void {
    this.model = model;
    this.vo = vo;
    this.successFunc = successFunc;
    this.send('KYMW41outputKomaSizeDifferenceList', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof OutputKomaSizeDifferenceListService
   */
  success(data: any): void {
    // レスポンスのファイルパスをマネージに保存
    this.model.updateFileUrl(data);
    if (data !== null) {
      this.successFunc(data);
    }
  }
}
